const getStormUTCInLocal = (radarSite) => {
  const [dd, hh, mm] = radarSite.ddhhmm.match(/.{0,2}/g).filter((item) => item);
  const year_month = new Date().toLocaleString('lt-LT', { year: 'numeric', month: '2-digit' });
  const utcTimeStamp = `${year_month}-${dd}T${hh}:${mm}:00Z`;
  return new Date(utcTimeStamp);
};

export { getStormUTCInLocal };
